/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { preventAlphaInput, preventAlphaInputOnPaste } from '../../../shared/utils/stringUtils';
import TextWidget from './TextWidget';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

export default function LeadingZeroNumberFieldWidget(props) {
  const { uiSchema, rawErrors = [], rawHelp = [] } = props;

  const _onKeyDown = (e) => {
    preventAlphaInput(e);
  };
  const _onPaste = (e) => {
    preventAlphaInputOnPaste(e);
  };

  const hasError = rawErrors?.length > 0 || uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'error';
  const hasWarning = rawHelp?.length > 0 && uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'info';

  return (
    <TextWidget {...props} onKeyDown={_onKeyDown} onPaste={_onPaste} hasError={hasError} hasWarning={hasWarning} />
  );
}
